<template>
  <div class="login-page">
    <div class="login-container">
      <!-- Title -->
      <h1 class="main-title">FH2 Hunter</h1>
      <p class="subtitle">Welcome back! Please login to continue.</p>

      <!-- Form -->
      <form @submit.prevent="handleLogin" class="login-form">
        <!-- Email -->
        <div class="form-group">
          <label for="email">Email Address</label>
          <input
            id="email"
            v-model="email"
            type="email"
            placeholder="Enter your email"
            required
          />
        </div>

        <!-- Password -->
        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="Enter your password"
            required
          />
        </div>

        <!-- Login Button -->
        <button type="submit" class="login-btn">
          <span>Login</span>
        </button>
      </form>

      <!-- Footer -->
      <p class="footer-text">
        Don't have an account?
        <a href="/register">Register here</a>
      </p>
    </div>
  </div>
</template>

<script>
import { login } from "../services/auth";

export default {
  name: "LoginPage",
  data() {
    return {
      email: "",
      password: "",
    };
  },
  methods: {
    async handleLogin() {
      try {
        const response = await login(this.email, this.password);
        alert("✅ Login Successful!");
        console.log("User:", response.user);

        // Redirect to FH2 Dashboard
        window.location.href = "https://register.securiumx.com/register/thankyou";
      } catch (err) {
        console.error("❌ Login Failed:", err);
        alert(err.response?.data?.message || "Invalid credentials!");
      }
    },
  },
};
</script>

<style scoped>
/* Page Background */
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #4f46e5, #3b82f6);
  font-family: "Poppins", sans-serif;
  padding: 20px;
}

/* Container */
.login-container {
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.15);
  width: 380px;
  text-align: center;
  animation: fadeIn 0.6s ease-in-out;
}

/* FH2 Hunter Title */
.main-title {
  font-size: 2rem;
  font-weight: 800;
  color: #4f46e5;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  text-shadow: 0px 0px 10px rgba(79, 70, 229, 0.4);
}

/* Subtitle */
.subtitle {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 25px;
}

/* Form */
.login-form {
  display: flex;
  flex-direction: column;
}

/* Form Groups */
.form-group {
  margin-bottom: 18px;
  text-align: left;
}

.form-group label {
  display: block;
  font-size: 0.85rem;
  margin-bottom: 6px;
  color: #333;
  font-weight: 500;
}

/* Inputs */
.form-group input {
  width: 100%;
  padding: 12px 14px;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.95rem;
  background-color: #f9fafb;
  transition: 0.3s ease;
}

.form-group input:focus {
  outline: none;
  border-color: #4f46e5;
  background-color: #fff;
  box-shadow: 0px 0px 6px rgba(79, 70, 229, 0.4);
}

/* Login Button */
.login-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #4f46e5, #3b82f6);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s ease;
  margin-top: 8px;
}

.login-btn:hover {
  background: linear-gradient(135deg, #4338ca, #2563eb);
  transform: scale(1.02);
  box-shadow: 0px 5px 15px rgba(79, 70, 229, 0.4);
}

/* Footer Text */
.footer-text {
  margin-top: 18px;
  font-size: 0.85rem;
  color: #666;
}

.footer-text a {
  color: #4f46e5;
  text-decoration: none;
  font-weight: 600;
}

.footer-text a:hover {
  text-decoration: underline;
}

/* Animation */
@keyframes fadeIn {
  from {
    transform: translateY(15px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive */
@media screen and (max-width: 480px) {
  .login-container {
    width: 100%;
    padding: 25px;
  }
}
</style>
